import styled from 'styled-components';
import breakpoints from '../breakpoints';
import sharedStyles from '../styles';

const ContentArea = styled.div`
  padding: 0;
  background: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  @media screen and (min-width: ${breakpoints.md}) {
    padding: 0 ${sharedStyles.spacing['spacing-md']};
  }

  .image-gallery-bullets {
    z-index: 1;
  }

  .product-container-details {
    padding: 0 ${sharedStyles.spacing['spacing-md']};
    @media screen and (min-width: ${breakpoints.md}) {
      padding: 2rem 4rem 0;
      border-left: solid 1px ${({ theme }) => theme.colors.border};
      margin-left: ${sharedStyles.spacing['spacing-md']};
    }
  }

  .carousel-area {
    @media screen and (min-width: ${breakpoints.lg}) {
      width: 50%;
    }
  }

  .image-gallery-slide {
    width: 100.1%; // fix 1px bleed on right side
  }

  .image-gallery-slide-wrapper {
    overflow: hidden;
    @media screen and (min-width: ${breakpoints.md}) {
      max-height: auto;
      padding-top: ${sharedStyles.spacing['spacing-md']};
    }
  }

  .image-gallery-thumbnails-wrapper {
    @media screen and (min-width: ${breakpoints.md}) {
      padding-bottom: 0.5rem;
    }
  }
`;

export default ContentArea;
